import { Select } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { SelectDownIcon } from "@/Components/Icons/SelectDownIcon";
import { SelectRemoveIcon } from "@/Components/Icons/SelectRemoveIcon";
import CustomDateRecurrenceModal from "@/Components/modals/client/CustomDateRecurrenceModal";
import {
  toggleCustomRecurrenceModalOpen,
  updateRecurrenceList,
  updateRepeatObj,
} from "@/reducers/clientcreatejob";

/**
 * DateRecurrence component renders the UI for selecting repeat options.
 *
 * @return {JSX.Element} React element representing the DateRecurrence component
 */
const DateRecurrence = () => {
  const dispatch = useDispatch();
  const {
    recurringListingPresets: { repeatPresets, frequencyPresets },
    repeatObj,
  } = useSelector((state) => state.clientCreateJob);
  return (
    <>
      <div className="DateRecurrence_Wrapper">
        <div className="flex flex-col gap-2">
          <label className="label" htmlFor="repeat">
            Repeat
          </label>

          <Select
            showSearch
            style={{ width: "100%" }}
            placeholder="Select"
            optionFilterProp="children"
            allowClear={false}
            className="ease min-h-[40px] w-full overflow-hidden rounded-lg border border-lightGrey text-[14px] font-medium leading-[normal] text-black transition-all duration-200 focus:border-primary"
            suffixIcon={<SelectDownIcon cls={"text-txtColor"} />}
            removeIcon={<SelectRemoveIcon />}
            onChange={(value) => {
              if (value === "never") {
                // dispatch(updateIsDisabledStartEndDate(false))
              } else {
                // dispatch(updateIsDisabledStartEndDate(true))
                dispatch(toggleCustomRecurrenceModalOpen(true));
                // dispatch(updateRecurrenceList());
              }
              dispatch(
                updateRepeatObj({
                  //     ...defaultRepeatObj,
                  repeat: value,
                  frequency: value,
                  //     everyFrequency: 1,
                  //     startsOn: repeatObj.startsOn,
                  //     endsOn: repeatObj.endsOn,
                  //     shiftOccurText: "",
                  //     dates: repeatObj.dates,
                }),
              );
            }}
            onSelect={(value) => {
              if (value !== "never") {
                dispatch(toggleCustomRecurrenceModalOpen(true));
                dispatch(updateRecurrenceList());
              }
            }}
            value={repeatObj.repeat}
          >
            <>
              <Select.Option value="never">Never</Select.Option>
              {frequencyPresets.map((item, index) => {
                const { label, value } = item;
                return (
                  <Select.Option value={value} key={index}>
                    {label}
                  </Select.Option>
                );
              })}
            </>
          </Select>
        </div>
      </div>
      <CustomDateRecurrenceModal />
    </>
  );
};

export default DateRecurrence;
